import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Label, Tooltip } from 'recharts';

export default function TicketsDonut({ closed, open, pending, resolved, waitingOnBank }) {
  const data = [
    { name: 'Open', value: open, color: '#054EEE' },
    { name: 'Closed', value: closed, color: '#BBD0FF' },
    { name: 'Resolved', value: resolved, color: '#80C20D' },
    { name: 'Waiting on Bank', value: waitingOnBank, color: '#FF3C00' }
  ];

  const total = closed + open + resolved + waitingOnBank;
  // --- Tooltip bubble ---
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: '#fff',
            padding: '6px 10px',
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 700,
            color: payload[0].payload.color,
            boxShadow: '0px 2px 6px rgba(0,0,0,0.15)'
          }}
        >
          {payload[0].value}
        </div>
      );
    }
    return null;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 1.5
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 150,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip content={<CustomTooltip />} cursor={false} />

            <Pie data={data} innerRadius={55} outerRadius={70} dataKey="value" nameKey="name">
              {data.map((entry, idx) => (
                <Cell key={idx} fill={entry.color} />
              ))}

              <Label
                position="center"
                content={() => (
                  <text
                    x="50%"
                    y="42%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{
                      fontSize: '25px',
                      fontWeight: 700,
                      fill: '#171D40',
                      fontFamily: 'Montserrat'
                    }}
                  >
                    {total}

                    <tspan
                      x="50%"
                      dy="20"
                      style={{ fontSize: 10, fill: '#171D40', fontWeight: 600 }}
                    >
                      Total
                    </tspan>

                    <tspan
                      x="50%"
                      dy="11"
                      style={{ fontSize: 10, fill: '#171D40', fontWeight: 600 }}
                    >
                      Tickets
                    </tspan>
                  </text>
                )}
              />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mt: 1,
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}
      >
        {data.map((item, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 0.8,
              py: 0.5,
              borderRadius: '5px',
              backgroundColor: '#FFFFFF',
              boxShadow: '0px 4px 12px rgba(0,0,0,0.08)'
            }}
          >
            <svg width="5" height="5" viewBox="0 0 8 8">
              <circle cx="4" cy="4" r="4" fill={item.color} />
            </svg>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 700,
                color: '#171D40',
                whiteSpace: 'nowrap'
              }}
            >
              {item.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
